const REPORT_CREATED = 'REPORTS/REPORT_CREATED';

export const actionTypes = {
  REPORT_CREATED,
};

export const reportCreated = () => ({
  type: REPORT_CREATED,
});
